import React, { ReactNode } from 'react'
import styled from 'styled-components'
import { colors, ThemeColor } from 'utils/colors'
import TimeLineBadge from './TimeLineBadge'
import { isLegacy, LeadDetailsDesignVersion } from '../utils/designVersionHelpers'

export type StatusProps = {
  activeBgColor?: string
  bgColor?: string
  data?: ReactNode
  onClick?: (value: string) => void
  textColor?: ThemeColor
  value?: string
}

type Props = {
  data: Array<StatusProps>
  isReadOnly?: boolean
  isActive?: boolean
  width?: string
  designVersion?: LeadDetailsDesignVersion
  isDeleted?: boolean
}

const LeadStatusTimeLine: React.FC<Props> = (props) => {
  const { data, isActive, isReadOnly, designVersion = 'v1', isDeleted } = props
  const currentPosition = data.findIndex((status) => !status.onClick)

  const resolvedData = data.map((status, index) => {
    if (isDeleted && index <= currentPosition) {
      return {
        ...status,
        bgColor: colors.gray5,
      }
    }
    return status
  })

  return (
    <Container data-testid="lead-stage-container" isLegacy={isLegacy(designVersion)}>
      {resolvedData.map((statusData, index) => {
        let position: 'normal' | 'first' | 'last' = 'normal'
        const { bgColor, onClick, textColor, value } = statusData

        if (index === 0) {
          position = 'first'
        }

        if (index === data.length - 1) {
          position = 'last'
        }

        return (
          <TimeLineBadge
            isReadOnly={isReadOnly}
            onClick={!isReadOnly && onClick && value ? () => onClick(value) : undefined}
            position={position}
            bgColor={bgColor}
            textColor={textColor}
            key={index}
            isActive={isActive}
            designVersion={designVersion}
          >
            {statusData.data}
          </TimeLineBadge>
        )
      })}
    </Container>
  )
}

export default LeadStatusTimeLine

const Container = styled.div<{ isLegacy: boolean }>`
  display: flex;
  gap: 2px;
  overflow-x: auto;
  overflow-y: hidden;
  ${({ isLegacy }) =>
    !isLegacy &&
    `
    white-space: normal;
    
  `}
  ${({ isLegacy }) =>
    isLegacy &&
    `
    max-width: 100%;
  `}
`
